const INBOUND = "mailchannels-inbound";
const OUTBOUND = "outbound";
const TRANSACTIONAL_API = "transactional-api";
const FEATURE_PROTECT_DOMAINS = ["protected-domains"];
const FEATURE_OUTBOUND_EMAILS = [
    "messages-submitted-starter",
    "messages-submitted-lite",
    "messages-submitted-standard",
    "messages-submitted-professional",
    "messages-submitted-select",
    "messages-submitted-advanced",
    "messages-submitted-intro",
    "messages-submitted-intro-2",
];
const EMAIL_RANGE_LIMIT = 3000000;
const DOMAIN_RANGE_LIMIT = 2253; //the number is the cutoff domains for $699.99 in current chargify scheme. If the scheme changes and we want to maintain the cutoff price, modify this number or set it dynamically.

const PRICING_SCHEME_STAIRSTEP = "STAIRSTEP";
const PRICING_SCHEME_TIERED = "TIERED";

const THOUSANDS_OF_MESSAGES = "thousands of messages";

//reCaptcha public key
const RECAPTCHA_PUBLIC_KEY =
    process.env.NODE_ENV === "production"
        ? "6LeZ_loUAAAAAOHa56aLnnThIbsdgmso6Bqfwy1o" //production key
        : "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"; //test key

const csrfHeaderName = "XSRF-TOKEN";

const index = "/pricing";

const getPlansURL = index + "/plans";
const signupSubmitURL = index + "/signup";
const getConfigURL = index + "/frontend-config";

const applyCouponURL = index + "/applyCoupon";
const checkEmailValidityURL = index + "/signup/validateEmail";
const emailVerificationURL = index + "/signup/emailVerification";

const cartURL = index + "/cart";

const EXPIRY_MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const EXPIRY_YEARS = [];
let thisYear = new Date().getFullYear();
for (let i = 0; i < 20; i++) {
    EXPIRY_YEARS[i] = thisYear + i;
}

//customized description text for demo purpose only
const planDetails = {
    "Starter Plan": {
        header: "Starter",
        subHeader: "<em>Ideal for IT consultants and MSPs</em>",
        price: "$99.99",
        volume: "40,000",
        descriptions: [
            `No overage fees<sup>*</sup>`,
            `Unlimited outbound domains`,
            `1 console user`,
            `Ticket support`,
        ],
        footer: "* Rate-limited if you exceed the monthly limit.",
    },
    "Lite Plan": {
        header: "Lite",
        subHeader: "",
        price: "$149.99",
        volume: "300,000",
        descriptions: [
            `No overage fees<sup>*</sup>`,
            `Unlimited outbound domains`,
            `1 console user`,
            `Ticket support`,
        ],
        footer: "* Rate-limited if you exceed the monthly limit.",
    },
    "Standard Plan": {
        header: "Standard",
        subHeader: "<em>Ideal for small service providers</em>",
        price: "$524.99",
        volume: "1,000,000",
        descriptions: [
            `Additional emails at $1.50 per thousand`,
            `Unlimited outbound domains`,
            `<strong>3 console users</strong>`,
            `Ticket support`,
            `<strong>Hacked user and site alerts</strong>`,
        ],
    },
    "Professional": {
        header: "Professional",
        subHeader: "<em>Ideal for mid-size service providers</em>",
        price: "$1149.99",
        volume: "2,500,000",
        descriptions: [
            `Additional emails at $1.00 per thousand`,
            `Unlimited outbound domains`,
            `<strong>10 console users</strong>`,
            `<strong>Priority ticket support</strong>`,
            `Hacked user and site alerts`,
            `<strong>Dedicated account manager</strong>`,
        ],
    },
    "Custom Plan": {
        header: "High Volume",
        subHeader:
            "<em>Custom packages for service providers and senders with demanding requirements</em>",
        body:
            "Learn about plans for securing and delivering <strong>2.5 million+ emails /mo.</strong>",
        descriptions: [
            `<strong>Custom pricing</strong>`,
            `Unlimited outbound domains`,
            `<strong>Unlimited console users</strong>`,
            `<strong>Priority ticket & phone support</strong>`,
            `Hacked user and site alerts`,
            `Dedicated account manager`,
            `<strong>Technical integration setup with our Solution Engineers</strong>`,
            `Ability to host MailChannels on your hardware`,
        ],
    },
};

const googleTagManagerID_production = "GTM-TS5GB8";
const googleTagManagerID_testing = "GTM-WL69L8X";
const googleTagManagerID =
    process.env.NODE_ENV === "production"
        ? googleTagManagerID_production
        : googleTagManagerID_testing;

export {
    index,
    getPlansURL,
    signupSubmitURL,
    applyCouponURL,
    checkEmailValidityURL,
    emailVerificationURL,
    cartURL,
    RECAPTCHA_PUBLIC_KEY,
    INBOUND,
    OUTBOUND,
    TRANSACTIONAL_API,
    FEATURE_PROTECT_DOMAINS,
    FEATURE_OUTBOUND_EMAILS,
    EMAIL_RANGE_LIMIT,
    DOMAIN_RANGE_LIMIT,
    PRICING_SCHEME_STAIRSTEP,
    PRICING_SCHEME_TIERED,
    csrfHeaderName,
    THOUSANDS_OF_MESSAGES,
    EXPIRY_MONTHS,
    EXPIRY_YEARS,
    googleTagManagerID,
    planDetails,
    getConfigURL
};
